module.exports = __webpack_public_path__ + "img/区块@2x.6aff8b6d.png";